import { SpaBookingDTO, UiSpaBookingDTO, UiSpaEventDTO, SpaEventDTO, UiCancellationDTO } from '@api';

export class EventUtils {
  static getNameAndMotto(event: SpaEventDTO | UiSpaEventDTO | undefined | null): string {
    return event?.name + (event?.motto ? ' – ' + event?.motto : '');
  }

  static eventOrProductName(element: UiSpaBookingDTO | SpaBookingDTO | UiCancellationDTO | undefined | null): string {
    return element?.product?.name ?? '';
  }

  static eventOrProductNameForCancellationV2(element: UiCancellationDTO | undefined): string {
    return element?.product?.name ?? '';
  }
}
